import { render, staticRenderFns } from "./SellCoins.vue?vue&type=template&id=a55e61b2&scoped=true&"
import script from "./SellCoins.vue?vue&type=script&lang=ts&"
export * from "./SellCoins.vue?vue&type=script&lang=ts&"
import style0 from "./SellCoins.vue?vue&type=style&index=0&id=a55e61b2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55e61b2",
  null
  
)

export default component.exports